const entityToKey = {
  serviceCompanyIds: 1,
  houses: 2,
  addresses: 3,
};

const compareByParts = (a, b) => a.split('-').length - b.split('-').length;

export const transformAddresses = (addresses, editMode = false) => {
  let localAddresses = addresses.slice().sort(compareByParts);
  let key = localAddresses[0];

  const data = {
    [entityToKey.serviceCompanyIds]: [],
    [entityToKey.houses]: [],
    [entityToKey.addresses]: [],
  };

  while (localAddresses.length > 0) {
    localAddresses = localAddresses.filter(
      (address) => address !== key && !address.startsWith(`${key}-`)
    );
    const keyParts = key.split('-');
    const [company, house, address] = keyParts;
    data[keyParts.length].push({
      ...(company ? { company: Number(company) } : {}),
      ...(house ? { house: Number(house) } : {}),
      ...(address ? { address: Number(address) } : {}),
    });
    key = localAddresses[0];
  }

  return editMode
    ? {
        serviceCompanyIds: data[entityToKey.serviceCompanyIds].map(
          (item) => item.company
        ),
        houseIds: data[entityToKey.houses].map((item) => item.house),
        addressIds: data[entityToKey.addresses].map((item) => item.address),
      }
    : {
        serviceCompanyIds: data[entityToKey.serviceCompanyIds].map(
          (item) => item.company
        ),
        houses: data[entityToKey.houses].map((item) => ({
          serviceCompanyId: item.company,
          houseId: item.house,
        })),
        addresses: data[entityToKey.addresses].map((item) => ({
          serviceCompanyId: item.company,
          houseId: item.house,
          addressId: item.address,
        })),
      };
};
